import { render, staticRenderFns } from "./MissingUnitsModalItem.vue?vue&type=template&id=ebdfd78c&scoped=true&"
import script from "./MissingUnitsModalItem.vue?vue&type=script&lang=js&"
export * from "./MissingUnitsModalItem.vue?vue&type=script&lang=js&"
import style0 from "./MissingUnitsModalItem.vue?vue&type=style&index=0&id=ebdfd78c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdfd78c",
  null
  
)

export default component.exports